import { render, staticRenderFns } from "./DeactivatedGroupsTable.vue?vue&type=template&id=2a5a58d1"
import script from "./DeactivatedGroupsTable.vue?vue&type=script&lang=js"
export * from "./DeactivatedGroupsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports